'use strict';

angular.module('buyers')
  .directive('ucwords', [ function() {
    return {
      restrict: 'A',
      require: '?ngModel',
      link: function(scope, element, attribute, model) {
        
        var ucwords = function(value) {
          if (! value) { return null };
          
          return (value + '').replace(
            /^([a-z])|[\s|\t|\r|\n|\-|\.]+([a-z])/g, 
            function($1) {
              return $1.toUpperCase();
          });
        }
        
        
        var value = scope[attribute['ngModel']] || element.val() || null;
        
        if (scope[attribute['ngModel']]) {
          scope[attribute['ngModel']] = ucwords(value);
        } else if (element.val()) {
          element.val(ucwords(element.val()));              
        }
        
        if (model) {              
          model.$parsers.push(function(value) {
            model.$viewValue = ucwords(value);
            model.$render();
            return model.$viewValue;
          });
        }
      }
    };
  }
]);
  